import { useEffect, useRef, useState } from 'react';
import Button from '../../../Components/Button/Button';
import SelectCheckField from '../../../Components/SelectCheckField/SelectCheckField';
import { Form, Formik } from 'formik';
import DatePickerComponent from '../../../Components/DatePicker/DatePicker';
import validations, { soloDecimal } from '../../../Utils/Validations/Validations';
import InputTextField from '../../../Components/InputTextField/InputTextField';
import ModalElementos from './ModalElementos';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import { ObtenerMacroubicaciones } from '../Services/ObtenerMacroubicaciones';
import { ObtenerPeriodosPlan } from '../Services/ObtenerPeriodosPlan';
import { ObtenerElementosMacroubicacion } from '../Services/ObtenerElementosMacroubicacion';
import { ObtenerHectometrosMacroubicacion } from '../Services/ObtenerHectometrosMacroubicacion';
import ModalConfirmacion from './ModalConfirmacion';
import { useToast } from '../../../Hooks/useToast';
import { CrearPlan } from '../Services/CrearPlan';
import { ActualizarPlan } from '../Services/ActualizarPlan';
import ModalConsolidacion from './ModalConsolidacion';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { EnumIndicadoresInformesConservacion } from '../../../Utils/Enumeradores/ComunEnum';

const AgregarPlanificacion = (props) => {
	const { handleCloseAgregarPlan, datosEditar, datosModal, editar, indicadoresExigencia, cambiarFecha, fechaPlanificada, elemento, setElemento, primeraFecha, setPrimeraFecha, fechaHoy, existenFechasCargas, ...rest } = props;
	const [showElementos, setShowElementos] = useState(false);
	const [tablaDatos, setTablaDatos] = useState([]);
	const [modalConsolidado, setModalConsolidado] = useState(false);
	const [macroubicaciones, setMacroubicaciones] = useState([]);
	const [macroubicacion, setMacroubicacion] = useState([]);
	const [periodosPlanificacion, setPeriodosPlanificacion] = useState([]);
	const { usuario } = useLogin();
	const formikref = useRef();
	const [dataModal, setDataModal] = useState([]);
	const [dataModalConsolidado, setDataModalConsolidado] = useState([]);
	const [indicadorSeleccionado, setIndicadorSeleccionado] = useState(editar ? datosModal.indicador.indicadorId : 1);
	const [exigenciaSeleccionada, setExigenciaSeleccionada] = useState(editar ? datosModal.exigencia.exigenciaId : 1);
	const [macroubicacionSeleccionada, setMacroubicacionSeleccionada ] = useState(false);
	const [anoSeleccionado, setAnoSeleccionado] = useState();
	const [kmInicialSeleccionado, setKmInicialSeleccionado] = useState();
	const [kmFinalSeleccionado, setKmFinalSeleccionado] = useState();
 	const [exigencias, setExigencias] = useState([]);
	const [indicadores, setIndicadores] = useState([]);
	const [nombreModal, setNombreModal] = useState("");
	const [kmInicial, setkmInicial] = useState();
	const [primeraCarga, setPrimeraCarga] = useState(true);
	const [trimestres, setTrimestres] = useState([]);
	const [kmFinal, setKmFinal] = useState();
	const [listaAnos, setlistaAnos] = useState();
	const [errorAgregarMacro, setErrorAgregarMacro] = useState(false);
	const [showConfirmacion, setShowConfirmacion] = useState(false);
	const [datosConfimacion, setDatosConfimacion] = useState(false);
	const [modalResolve, setModalResolve] = useState(null);
	const [esIndicador, setEsIndicador] = useState(false);
	const isElemento = indicadorSeleccionado === EnumIndicadoresInformesConservacion.SEV || indicadorSeleccionado === EnumIndicadoresInformesConservacion.SOS || indicadorSeleccionado === EnumIndicadoresInformesConservacion.ILUE;
	const addToast = useToast();
	const [actualizarTabla, setActualizarTabla] = useState([])
	const [hayCambios, setHayCambios] = useState(false);
	const [hayCambiosModal, setHayCambiosModal] = useState(false);
	const seleccionInicialRef = useRef(null); 
	const errores = {};
	let hasErrors = false;

	const [erroresAgregarMacro, setErroresAgregarMacro] = useState({
		macroubicacionEr: "",
		kmInicialPlanEr: "",
		kmFinalPlanEr: "",
	});

	const resetErrors = () => {
		setErroresAgregarMacro({macroubicacionEr: "",
			kmInicialPlanEr: "",
			kmFinalPlanEr: ""});
			setErrorAgregarMacro(false);
	}

	const handleCloseElementos = () => {
		setShowElementos(false)
		setModalConsolidado(false)
	};

	const [initialValues, setInitialValues] = useState({
			indicador: indicadorSeleccionado,
			exigencia: exigenciaSeleccionada,
			macroubicacion: "",
			kmInicialPlan: "",
			kmFinalPlan: "",
			fechaPlanificadaInforme: "",
			año: editar ? datosModal.ano : "",
			trimestre: editar ? `Q${datosModal.trimestre}` : ""
		});

    const filtroExigencia = () => {
		if(editar === false)
		{
			if (indicadorSeleccionado === 0) {
			setExigencias([]);
			return;
			}

			let listaExigencias = indicadoresExigencia
				.find(item => item.indicadorId === indicadorSeleccionado)?.exigencias || [];

			setExigencias(
				listaExigencias.map(item => ({
					value: item.id,
					label: `${item.sigla} - ${item.descripcion}`
				}))
			);
		}
		else 
		{
			setExigencias([
				{
					value: datosEditar.exigencia.exigenciaId,
					label: `${datosEditar.exigencia.sigla} - ${datosEditar.exigencia.descripcion}`
				}
			]);
		}
		
	}

	const filtroIndicador = () => {
		const listaIndicadores = indicadoresExigencia.map(item => ({
				value: item.indicadorId,
				label: item.sigla
			}));

		setIndicadores(listaIndicadores);
	};

	const filtroListaAnos = () => {
		let listaAnos = [];
		if (editar)
		{
			const añoActual = new Date().getFullYear();
			listaAnos = [
				{ value: añoActual, label: añoActual.toString() },
				{ value: añoActual + 1, label: (añoActual + 1).toString() },
			  ];
		}
		else
		{
			listaAnos = periodosPlanificacion.map(item => ({
				value: item.año,
				label: item.año.toString(),
			}));
		}
		setlistaAnos(listaAnos);
	};

	const filtroListaTrimestres = () => {
		let listaTrimestres = [];
		const periodosFiltrados = periodosPlanificacion.find(editar ? periodo => periodo.año === datosModal.ano : periodo => periodo.año === anoSeleccionado);

		if (!editar)
		{
			listaTrimestres = periodosFiltrados?.trimestres.map(trimestre => ({
				value: trimestre.id,
				label: trimestre.descripcion,
			})) || [];
		}
		else
		{
			listaTrimestres = ['Q1', 'Q2', 'Q3', 'Q4'].map((q, index) => ({
				value: index + 1,
				label: q,
			})
			)
		}
		setTrimestres(listaTrimestres);
	};

	const filtroMacroubicacion = () => {
		const listaMacroubicaciones = macroubicaciones.map(item => ({
			value: item.idMacroubicacion,
			label: `${item.idMacroubicacion} - ${item.descripcion}`,
			pkInicio: item.pkInicio,
        	pkFinal: item.pkFinal
		}));

		setMacroubicacion(listaMacroubicaciones);
	};

	const handleMacroubicacionChange = (value) => {
		const kmInicio = macroubicaciones
			.filter(item => item.idMacroubicacion === value)
			.map(item => item.pkInicio)[0];

		const kmFinal = macroubicaciones
			.filter(item => item.idMacroubicacion === value)
			.map(item => item.pkFinal)[0];

		setkmInicial(kmInicio);
        setKmFinal(kmFinal);
	};

	const validateKmField = (fieldValue, fieldName, isKmInicial = false) => {
		try {
			if (!fieldValue) {
				errores[`${fieldName}Er`] = "Requerido";
				hasErrors = true;
				return;
			}

			const valueNumber = Number(fieldValue);

			if (valueNumber < 0) {
				errores[`${fieldName}Er`] = isKmInicial
					? "El KM inicial debe ser mayor o igual a 0"
					: "El KM final debe ser mayor a 0";
				hasErrors = true;
				return;
			}

			if (fieldValue.toString().includes('.') && fieldValue.toString().split('.')[1].length > 3) {
				errores[`${fieldName}Er`] = "Debe tener 3 decimales o menos";
				hasErrors = true;
				return;
			}
		} catch (error) {
			console.error(`Error en validateKmField para ${fieldName}:`, error);
			throw new Error("Ocurrió un problema al validar el campo KM.");
		}
	};

	const agregarMacroubicacion = async () => {
		try {
			const { macroubicacion, kmInicialPlan, kmFinalPlan } = formikref.current.values;
			resetErrors();

			if (!macroubicacion) {
				errores.macroubicacionEr = "Requerido";
				hasErrors = true;
			}

			// Validaciones de km inicial y km final
			validateKmField(kmInicialPlan, "kmInicialPlan", true);
			validateKmField(kmFinalPlan, "kmFinalPlan");

			const kmInicialPuesto = Number(kmInicialPlan);
			const kmFinalPuesto = Number(kmFinalPlan);

			if (macroubicacionSeleccionada === true && kmInicialPuesto < kmInicial || kmInicialPuesto > kmFinal) {
				errores.kmInicialPlanEr = `El valor debe estar entre ${kmInicial} y ${kmFinal}`;
				hasErrors = true;
			}

			if (macroubicacionSeleccionada === true && kmFinalPuesto < kmInicial || kmFinalPuesto > kmFinal) {
				errores.kmFinalPlanEr = `El valor debe estar entre ${kmInicial} y ${kmFinal}`;
				hasErrors = true;
			}

			if (!hasErrors && kmInicialPuesto >= kmFinalPuesto) {
				errores.kmInicialPlanEr = "El KM inicial debe ser menor al KM final";
				errores.kmFinalPlanEr = "El KM final debe ser mayor al KM inicial";
				hasErrors = true;
			  }

			let macroubicacionDescripcion = macroubicaciones.find(item => item.idMacroubicacion === macroubicacion)?.descripcion || '';
			let macroubicacionMostrar = `${macroubicacion} - ${macroubicacionDescripcion}`

			if (!hasErrors) {
				const existe = tablaDatos.some(fila =>
					fila.macroubicacionMostrar === macroubicacionMostrar &&
					(
						(kmInicialPuesto >= fila.pkInicial && kmInicialPuesto <= fila.pkFinal) || // KM Inicial dentro de otro segmento
						(kmFinalPuesto >= fila.pkInicial && kmFinalPuesto <= fila.pkFinal) ||    // KM Final dentro de otro segmento
						(kmInicialPuesto <= fila.pkInicial && kmFinalPuesto >= fila.pkFinal) ||  // El nuevo segmento engloba uno existente
						(fila.pkInicial >= kmInicialPuesto && fila.pkFinal <= kmFinalPuesto)     // El nuevo rango engloba un segmento existente
					)
				);

				if (existe) {
					errores.kmInicialPlanEr = "No se puede segmentar dentro de un rango ya introducido";
					hasErrors = true;
				}
			}

			setErroresAgregarMacro((prevErrors) => ({ ...prevErrors, ...errores }));
			if (hasErrors) return;

			let planElementos = [];
			let planHectometros = [];
			let idMacroubicacion = macroubicacion;

			let nuevaFila = ([])

			if (indicadorSeleccionado === EnumIndicadoresInformesConservacion.SEV || indicadorSeleccionado === EnumIndicadoresInformesConservacion.SOS || indicadorSeleccionado === EnumIndicadoresInformesConservacion.ILUE)
			{
				planElementos = await fetchElementos(idMacroubicacion);
				if (planElementos.length === 0) 
				{
					addToast({ mostrar: true, mensaje: 'No hay elementos asociados a ese segmento.', titulo: 'Confirmación', tipo: 'Warning' });
					return;
				}
				nuevaFila = { 
					id: tablaDatos.length + 1,
					idMacroubicacion,
					macroubicacionMostrar,
					"pkInicial": kmInicialPlan,
					"pkFinal": kmFinalPlan,
					planElementos,
					elementos: true
				};
			}
			else
			{
				planHectometros = await fetchHectometros(idMacroubicacion);
				if (planHectometros.length === 0) 
				{
					addToast({ mostrar: true, mensaje: 'No hay elementos asociados a ese segmento.', titulo: 'Confirmación', tipo: 'Warning' });
					return;
				}
				nuevaFila = {
					id: tablaDatos.length + 1,
					idMacroubicacion,
					macroubicacionMostrar,
					"pkInicial": kmInicialPlan,
					"pkFinal": kmFinalPlan,
					planHectometros,
					elementos: false
				};
			}
			
			setActualizarTabla(prev => [...prev, nuevaFila]);
			setTablaDatos([...tablaDatos, nuevaFila]);
			setHayCambios(true);

			formikref.current.setFieldValue("macroubicacion", "");
			formikref.current.setFieldValue("kmInicialPlan", "");
			formikref.current.setFieldValue("kmFinalPlan", "");
			setMacroubicacionSeleccionada(false);
		} catch (error) {
			console.error("Error al agregar macroubicación:", error);
		}
	};

	async function fetchElementos(macroubicacionId) {
		const usuarioId = {
			idUsuario: usuario.id,
			IdIndicador: indicadorSeleccionado,
			IdExigencia: exigenciaSeleccionada,
            IdMacroubicacion: macroubicacionId,
            pkInicio: kmInicialSeleccionado,
			pkFinal: kmFinalSeleccionado,
		};

		try {
			const response = await ObtenerElementosMacroubicacion(usuarioId);
			if (response && response.status === 200 && response.data) {
				const elementosEstados = response.data.map((item) => ({
					...item,
					estado: true
				}));
				return elementosEstados;
			}
			return null;
		} catch (error) {
			console.error("Error obteniendo indicadores:", error);
			return null;
		}
	}

	async function fetchHectometros(macroubicacionId) {
		const usuarioId = {
			idUsuario: usuario.id,
			IdIndicador: indicadorSeleccionado,
			idExigencia: exigenciaSeleccionada,
            IdMacroubicacion: macroubicacionId,
            pkInicio: kmInicialSeleccionado,
			pkFinal: kmFinalSeleccionado,
		};

		try {
			const response = await ObtenerHectometrosMacroubicacion(usuarioId);
			if (response && response.status === 200 && response.data) {
				const hectometrosEstados = response.data.map((item) => ({
					...item,
					estado: true
				}));
				return hectometrosEstados;
			}
			return null;
		} catch (error) {
			console.error("Error obteniendo indicadores:", error);
			return null;
		}
	}

	const eliminarFila = (id) => {
		const nuevaTabla = tablaDatos.filter((fila) => fila.id !== id);
		const nuevaTablaBoton = actualizarTabla.filter((fila) => fila.id !== id);
		setTablaDatos(nuevaTabla);
		setActualizarTabla(nuevaTablaBoton);
		setHayCambios(true);
		localStorage.setItem('elementosMarcados', JSON.stringify(nuevaTabla));
	};

	const handleShowElementos = (todos, nombreMacroubicacion, id) => {
		let datosSeleccionados = [];
	  
		const propiedad = isElemento ? "planElementos" : "planHectometros";
	  
		if (todos) {
		  datosSeleccionados.push(
			...tablaDatos.flatMap((fila) => {
			  const datosFiltrados = fila[propiedad];
			  return datosFiltrados.map((dato) => ({
				...dato,
				macroubicacionMostrar: fila.macroubicacionMostrar,
			  }));
			})
		  );
		} else {
		  const filaSeleccionada = tablaDatos.find((fila) => fila.id === id);
		  if (filaSeleccionada && filaSeleccionada[propiedad]) {
			datosSeleccionados.push(
			  ...filaSeleccionada[propiedad].map((dato) => ({
				...dato,
				macroubicacionMostrar: filaSeleccionada.macroubicacionMostrar,
			  }))
			);
		  }
		}
	
		setModalConsolidado(todos);
		setDataModal(datosSeleccionados);
		setDataModalConsolidado(datosSeleccionados);
		setShowElementos(!todos);
		setNombreModal(nombreMacroubicacion);
	  };
	  

	const handlemodalConfirmacionIndicador = async (values, setFieldValue, value) => {
		setEsIndicador(true)

		if (values.macroubicacion || tablaDatos.length > 0 || values.ano || values.trimestres || values.fechaPlanificadaInforme) {
			setShowConfirmacion(true);

			const userConfirmed = await new Promise((resolve) => {
				setModalResolve(() => resolve);
			});

			if (userConfirmed) {
				setFieldValue(value);
				setIndicadorSeleccionado(value);
			}
		} else {
			setFieldValue(value);
			setIndicadorSeleccionado(value);
		}
	};

	const handlemodalConfirmacionExigencia = async (values, setFieldValue, value) => {
		setEsIndicador(false);

		if (values.macroubicacion || tablaDatos.length > 0 || values.ano || values.trimestres || values.fechaPlanificadaInforme) {
			setShowConfirmacion(true);

			const userConfirmed = await new Promise((resolve) => {
				setModalResolve(() => resolve);
			});

			if (userConfirmed) {
				setFieldValue(value);
				setExigenciaSeleccionada(value);
			}
		} else {
			setFieldValue(value);
			setExigenciaSeleccionada(value);
		}
	};

	const guardarPlan = (values) => {
		fecthCrearPlan(values);
	}

	const actualizarPlan = (values) => {
		fecthActualizarPlan(values);
	}

	async function fecthCrearPlan(values) {
		const usuarioId = {
			idUsuario: usuario.id,
			indicadorId: indicadorSeleccionado,
			exigenciaId: exigenciaSeleccionada,
			fechaPlanificada: values.fechaPlanificadaInforme,
            año: values.año,
            trimestre: values.trimestre || null,
        	planMacroubicacion: tablaDatos || null,
		};

		try {
			const response = await CrearPlan(usuarioId);
			if (response && response.status === 200 && response.data) {
                addToast({ mostrar: true, mensaje: "Plan Creado Correctamente", titulo: 'Información', tipo: 'Info' });
				handleCloseAgregarPlan();
			}
		} catch (error) {
			console.error("Error al crear el plan:", error);
		}
	}

	async function fecthActualizarPlan(values) {
		const usuarioId = {
			idUsuario: usuario.id,
			planConservacionId: datosModal.planConservacionId,
			fechaPlanificada: values.fechaPlanificadaInforme ? values.fechaPlanificadaInforme : datosModal.fechaPlanificada,
        	planMacroubicacion: tablaDatos || null,
		};

		try {
			const response = await ActualizarPlan(usuarioId);
			if (response && response.status === 200 && response.data) {
                addToast({ mostrar: true, mensaje: "Plan Actualizado Correctamente", titulo: 'Información', tipo: 'Info' });
				handleCloseAgregarPlan();
			}
		} catch (error) {
			console.error("Error al crear el plan:", error);
		}
	}

	useEffect(() => {
		const usuarioId = {
			idUsuario: usuario.id,
			indicadorId: indicadorSeleccionado
		};

		async function fetchMacroubicacion() {
			try {
				const response = await ObtenerMacroubicaciones(usuarioId);
				if (response && response.status === 200 && response.data) {
					setMacroubicaciones(response.data);
				}
			} catch (error) {
				console.error("Error obteniendo indicadores:", error);
			}
		}

		fetchMacroubicacion();
	}, [indicadorSeleccionado]);

	useEffect(() => {
		const usuarioId = {
			idUsuario: usuario.id,
			indicadorId: indicadorSeleccionado,
			exigenciaId: exigenciaSeleccionada
		};

		async function fetchTrimestres() {
			try {
				const response = await ObtenerPeriodosPlan(usuarioId);
				if (response && response.status === 200 && response.data) {
					setPeriodosPlanificacion(response.data);
				}
			} catch (error) {
				console.error("Error obteniendo indicadores:", error);
			}
		}

		fetchTrimestres();
	}, [indicadorSeleccionado, exigenciaSeleccionada]);

	useEffect(() => {
		filtroIndicador();
	}, [indicadoresExigencia]);

	useEffect(() => {
		filtroExigencia();
		if(indicadorSeleccionado === EnumIndicadoresInformesConservacion.SEV 
		  || indicadorSeleccionado === EnumIndicadoresInformesConservacion.SOS
		  || indicadorSeleccionado === EnumIndicadoresInformesConservacion.ILUE)
		{
			setElemento(true);
		}
		else
		{
			setElemento(false)
		}

		if (editar)
			{
				setInitialValues((prev) => ({
					...prev,
					indicador: indicadorSeleccionado,
					exigencia: exigenciaSeleccionada,
					año: datosModal.ano,
					trimestre: datosModal.trimestre,
				}));

				const nuevaTablaDatos = datosModal.macroubicaciones.map((macroubicacion, index) => {
					const planElementos =
					  indicadorSeleccionado === EnumIndicadoresInformesConservacion.SEV || indicadorSeleccionado === EnumIndicadoresInformesConservacion.SOS || indicadorSeleccionado === EnumIndicadoresInformesConservacion.ILUE
						? macroubicacion.planElementos
						: [];
					const planHectometros =
					  indicadorSeleccionado !== EnumIndicadoresInformesConservacion.SEV || indicadorSeleccionado !== EnumIndicadoresInformesConservacion.SOS || indicadorSeleccionado !== EnumIndicadoresInformesConservacion.ILUE
						? macroubicacion.planHectometros
						: [];

					let macroubicacionMostrar = `${macroubicacion.idMacroubicacion} - ${macroubicacion.descripcion}`;

					return {
					  ...macroubicacion,
					  id: index + 1,
					  macroubicacionMostrar,
					  planElementos,
					  planHectometros
					};
				  });

				setTablaDatos(nuevaTablaDatos);
			}
		else
			{
				setInitialValues((prev) => ({
				...prev,
				indicador: indicadorSeleccionado,
				exigencia: exigenciaSeleccionada
				}));
			}
	},[indicadorSeleccionado, exigenciaSeleccionada, datosModal]);

	useEffect(() => {
		if (macroubicaciones.length > 0) {
			filtroMacroubicacion();
		}
	}, [macroubicaciones]);

	useEffect(() => {
		if (periodosPlanificacion && periodosPlanificacion.length > 0) {
			filtroListaAnos();
		} else if (editar)
		{
			filtroListaAnos();
		}
	}, [periodosPlanificacion]);

	useEffect(() => {
			filtroListaTrimestres();
	}, [anoSeleccionado, periodosPlanificacion]);

	useEffect(() => {
		if (primeraCarga && exigencias.length > 0) {
			const primeraExigencia = exigencias[0].value;

			setExigenciaSeleccionada(primeraExigencia);
			setPrimeraCarga(false);
		}
	}, [exigencias]);

	useEffect (() => {
		if(!editar)	{
			formikref.current.setFieldValue("macroubicacion", "");
			formikref.current.setFieldValue("kmInicialPlan", "");
			formikref.current.setFieldValue("kmFinalPlan", "");
			setTablaDatos([]);
			formikref.current.setFieldValue("fechaPlanificadaInforme", "");
			formikref.current.setFieldValue("año", "");
			formikref.current.setFieldValue("trimestre", "");
			setDatosConfimacion(false);
		}
	}, [datosConfimacion])

	return (
		<div>
			<div className="container mt-4">
				<div className="d-flex justify-content-between align-items-center mb-3">
					<h5 className="page-title">Agregar Planificación</h5>
					<Button
					type="button"
					design="btn-outline-pewter-blue p-2 lh-1 fs-3"
					onClick={() => {
						handleCloseAgregarPlan();
					}}
					>
					<i className="ico-close"></i> Volver
					</Button>
				</div>
				<Formik
					enableReinitialize
					initialValues={initialValues}
					validate={validations}
					onSubmit={(values) => {
						if (tablaDatos.length === 0) {
							setErrorAgregarMacro(true);
							return;
						}
					}}
					innerRef = {formikref}
				>
					{({ setFieldTouched, setFieldValue, values }) => (
					<Form className="form mb-0">
						<div className="simple-select">
						<SelectCheckField
							name="indicador"
							label="Indicador"
							options={indicadores}
							onBlur={setFieldTouched}
							onChange={(selected, value) => {
								setPrimeraCarga(true);
								handlemodalConfirmacionIndicador(formikref.current ? formikref.current.values : {}, setFieldValue, value);  // Llama a handlemodalConfirmacion con los valores actuales
							}}
							isMulti={false}
							fijo={false}
							disabled={editar}
						/>
						</div>
						<div className="simple-select">
						<SelectCheckField
							name="exigencia"
							label="Exigencia"
							options={exigencias}
							onBlur={setFieldTouched}
							onChange={(selected, value) => {
								handlemodalConfirmacionExigencia(formikref.current ? formikref.current.values : {}, setFieldTouched, value);
							}}
							isMulti={false}
							fijo={false}
							disabled={editar}
						/>
						</div>
						<div className="d-flex justify-content-between flex-fill gap-3">
						<div className="form-floating">
							<SelectCheckField
								name="año"
								label="Año"
								options={listaAnos}
								onBlur={setFieldTouched}
								onChange={(selected, value) => {
									setFieldValue("año", value);
									setFieldValue("trimestre", "");
									setAnoSeleccionado(value);}}
								isMulti={false}
								fijo={false}
								disabled={editar || cambiarFecha}
							/>
						</div>
						{indicadorSeleccionado !== 1 && (
						<div className="form-floating">
							<SelectCheckField
								name="trimestre"
								label="Trimestre"
								options={trimestres}
								onBlur={setFieldTouched}
								onChange={(selected, value) => {
									setFieldValue("trimestre", value);
								}}
								isMulti={false}
								fijo={false}
								disabled={editar || cambiarFecha}
							/>
						</div>
						)}
						</div>
						<div className="d-flex flex-column flex-fill dsac-datepicker">
							<DatePickerComponent
								name="fechaPlanificadaInforme"
								placeholderText={'Fecha Carga Informe'}
								maxDate={null}
								minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
								value={primeraFecha ? fechaPlanificada : values.fechaPlanificadaInforme}
								onChange={(selected, value) => {
								setFieldValue("fechaPlanificadaInforme", value);
								setPrimeraFecha(false);
								}}
								onBlur={setFieldTouched}
								disabled={cambiarFecha || existenFechasCargas}
							/>
						</div>
						<div className={`simple-select ${erroresAgregarMacro.macroubicacionEr!=="" ? 'is-invalid' : ''}`}>
						<SelectCheckField
							name="macroubicacion"
							label="Macroubicación"
							options={macroubicacion}
							onBlur={setFieldTouched}
							onChange={(name, value) => {
								if(erroresAgregarMacro.macroubicacionEr!==""){
									setErroresAgregarMacro((values) => ({
										...values
										, macroubicacionEr: ""
									}));
								}
								handleMacroubicacionChange(value);
								setFieldValue("macroubicacion", value);

								setFieldValue("kmInicialPlan", "");
								setFieldValue("kmFinalPlan", "");

								setMacroubicacionSeleccionada(true);
							}}
							isMulti={false}
							fijo={false}
							disabled={cambiarFecha || existenFechasCargas}
						/>
						</div>
						{erroresAgregarMacro.macroubicacionEr!=="" ?
						<small className="message">{erroresAgregarMacro.macroubicacionEr}</small>
						:null
						}
						<div className="d-flex justify-content-between flex-fill gap-3 mb-2">
						<OverlayTrigger
							placement="top"
							overlay={
								<Tooltip id="tooltip-top">
									Utilizar "." (punto) como separador de decimales
								</Tooltip>
							}
						>
						<div className={` justify-content-between flex-fill ${erroresAgregarMacro.kmInicialPlanEr!=="" ? 'is-invalid-plan' : ''}`}>
						<InputTextField
							name="kmInicialPlan"
							label="KM Inicial"
							type="text"
							placeholder="Km Inicial"
							autoComplete="false"
							maxLength="9"
							disabled={!macroubicacionSeleccionada || cambiarFecha || existenFechasCargas}
							onInput={(e) => {
							soloDecimal(e);
							}}
							onBlur={(e) => {
								setErroresAgregarMacro((values) => ({
									...values,
									kmInicialPlanEr: "",
								}));

							setFieldValue("kmInicialPlan", e.target.value);
							setKmInicialSeleccionado(e.target.value);
						}}
						/>
						{erroresAgregarMacro.kmInicialPlanEr!=="" ?
						<small className="message">{erroresAgregarMacro.kmInicialPlanEr}</small>
						:null
						}
						</div>
						</OverlayTrigger>
						<OverlayTrigger
							placement="top"
							overlay={
								<Tooltip id="tooltip-top">
									Utilizar "." (punto) como separador de decimales
								</Tooltip>
							}
						>
						<div className={` justify-content-between flex-fill ${erroresAgregarMacro.kmFinalPlanEr!=="" ? 'is-invalid-plan' : ''}`}>
						<InputTextField
							name="kmFinalPlan"
							label="KM Final"
							type="text"
							placeholder="Km Final"
							autoComplete="false"
							maxLength="9"
							disabled={!macroubicacionSeleccionada || cambiarFecha || existenFechasCargas}
							onInput={(e) => {
							soloDecimal(e);
							}}
							onBlur={(e) => {
									setErroresAgregarMacro((values) => ({
										...values,
										kmFinalPlanEr: "",
									}));
								setFieldValue("kmFinalPlan", e.target.value);
								setKmFinalSeleccionado(e.target.value);
							}}
						/>
						{erroresAgregarMacro.kmFinalPlanEr!=="" ?
						<small className="message">{erroresAgregarMacro.kmFinalPlanEr}</small>
						:null
						}
						</div>
						</OverlayTrigger>
						</div>
						<div className="d-block mt-3">
							<Button
								type="button"
								onClick={agregarMacroubicacion}
								design="btn-primary"
								disabled={cambiarFecha || existenFechasCargas}
							>
								Agregar Segmento
							</Button>
						</div>

						<div className="mt-4 ">
							<h6 className='mb-3'>Macroubicaciones Agregadas</h6>
							<table className={`table table-bordered ${ errorAgregarMacro? "is-invalid-plan-div" : ""}`}>
								<thead>
									<tr>
										<th>Macroubicación</th>
										<th>KM Inicial</th>
										<th>KM Final</th>
										<th>Acciones</th>
									</tr>
								</thead>
								<tbody>
									{tablaDatos.map((fila, index) => (
										<tr key={index}>
											<td>{fila.macroubicacionMostrar}</td>
											<td>{fila.pkInicial}</td>
											<td>{fila.pkFinal}</td>
											<td>
												<Button
													type="button"
													design="btn-primary"
													onClick={() => handleShowElementos(false, fila.macroubicacionMostrar, fila.id)}
													disabled={cambiarFecha || existenFechasCargas}
												>
													Detalle
												</Button>
												<Button
													type="button"
													design="btn-primary"
													onClick={() => eliminarFila(fila.id)}
													style={{"marginLeft": "4px"}}
													disabled={cambiarFecha || existenFechasCargas}
												>
													Eliminar
												</Button>
											</td>
										</tr>
									))}
									{tablaDatos.length === 0 && (
										<tr>
											<td colSpan="4" className="text-center">
												No hay datos disponibles.
											</td>
										</tr>
									)}
								</tbody>
							</table>
							{
								errorAgregarMacro?
									<small className="message">Requerido</small>
								: null
							}
						</div>

						<div className="d-flex flex-column flex-fill">
							<Button
								type="button"
								onClick={()=>(handleShowElementos(true, ""))}
								design="btn-primary"
								disabled={tablaDatos.length === 0? true:false}
							>
								Ver Detalle Consolidado
							</Button>
						</div>
						
						<div className="d-block mt-3">
						{editar ?
							<Button
							type="submit"
							design="btn-primary"
							onClick={()=>(actualizarPlan(values))}
							disabled={
								(!hayCambiosModal || tablaDatos.length === 0) && (
								(!hayCambios || tablaDatos.length === 0) &&
								(cambiarFecha || indicadorSeleccionado === 1
								  ? Object.entries(values)
									  .filter(([key]) => !['kmInicialPlan', 'kmFinalPlan', 'macroubicacion', 'trimestre'].includes(key))
									  .some(([_, value]) => value === "" || value === null)
								  : Object.entries(values)
									  .filter(([key]) => !['kmInicialPlan', 'kmFinalPlan', 'macroubicacion'].includes(key))
									  .some(([_, value]) => value === "" || value === null)
								))
							  }
							>
							Actualizar
							</Button> :
							<Button
							type="submit"
							design="btn-primary"
							onClick={()=>(guardarPlan(values))}
							disabled={
								tablaDatos.length === 0 || (
									indicadorSeleccionado === 1
										? Object.entries(values)
											.filter(([key]) => !['kmInicialPlan', 'kmFinalPlan', 'macroubicacion', 'trimestre'].includes(key))
											.some(([_, value]) => value === "" || value === null)
										: Object.entries(values)
											.filter(([key]) => !['kmInicialPlan', 'kmFinalPlan', 'macroubicacion'].includes(key))
											.some(([_, value]) => value === "" || value === null)
								)
							}
                			>
							Guardar
							</Button>}
						</div>
					</Form>
					)}
				</Formik>
			</div>
				{
					showConfirmacion ?
						<ModalConfirmacion
							show={showConfirmacion}
							onResolve={(result) => {
								modalResolve(result);
								setShowConfirmacion(false);
							}}
							onHide={() => {
								modalResolve(false);
								setShowConfirmacion(false);
							}}
							indicador={esIndicador}
							data={setDatosConfimacion}
						/>
						: null
				}
				{
					showElementos ?
						<ModalElementos
							show={showElementos}
							onHide={handleCloseElementos}
							elemento={elemento}
							seleccionInicialRef={seleccionInicialRef}
							nombreModal={nombreModal}
							data={dataModal}
							setTablaDatos={setTablaDatos}
							tablaDatos={tablaDatos}
							isElemento={isElemento}
							setHayCambiosModal={setHayCambiosModal}
						/>
						: null
				}
				{
				modalConsolidado ?
					<ModalConsolidacion
						show={modalConsolidado}
						onHide={handleCloseElementos}
						elemento={elemento}
						nombreModal={nombreModal}
						seleccionInicialRef={seleccionInicialRef}
						data={dataModalConsolidado}
						setTablaDatos={setTablaDatos}
						tablaDatos={tablaDatos}
						isElemento={isElemento}
						cambiarFecha={existenFechasCargas || cambiarFecha}
						setHayCambiosModal={setHayCambiosModal}
					/>
					: null
				}
		</div>
	)
}

export default AgregarPlanificacion